import { useTranslation } from "gatsby-plugin-react-i18next"
import * as React from "react"
import { FBIcon, InstagramIcon, PaytmIcon, PhonePeIcon, TelegramIcon, TwitterIcon, UpiIcon } from "../atoms/Icons"

import * as styles from './styles.module.scss'

const Footer = () => {
  const { t } = useTranslation()
  
  return (
    <footer className={styles.footer}>
      <div className={styles.login}>
        <div className={styles.text}>{t("alreadyHaveAccount")}</div>
        <a href={t("registerLink")} className={styles.link}>{t("login")}</a>
      </div>
      <div className={styles.paymentSystems}>
        <PhonePeIcon />
        <UpiIcon />
        <PaytmIcon />
      </div>
      <div className={styles.socials}>
        <a href="https://www.instagram.com/bilbet_official/" target="_blank"><InstagramIcon /></a>
        <a href="https://t.me/bilbet_official" target="_blank"><TelegramIcon /></a>
        <a href="https://www.facebook.com/bilbet_official-110957771374578" target="_blank"><FBIcon /></a>
        <a href="https://twitter.com/BilbetOfficial" target="_blank"><TwitterIcon /></a>
      </div>
    </footer>
  )
}

export default Footer